// returns main URL, example "get-local.tech", or "localhost" for local development
export const getDefaultUrl = (defaultDomain: string): string => {
  if (window.location.hostname.includes("localhost")) {
    return "http://localhost";
  } else {
    return `https://${defaultDomain}`;
  }
};
